import { Component, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { Observable } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';

import { ContratoService } from '../../../../providers/contrato-service';
import { ContratosGestaoService } from '../../../../providers/contratos-gestao-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { FileService } from '../../../../providers/file-service';

import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { ModalArquivosPage } from "../../../modais/modal-arquivos/modal-arquivos";

declare var jsPDF: any;

@Component({
  selector: 'page-relatorio-editais-cotacoes',
  templateUrl: 'relatorio-editais-cotacoes.html',
  providers: [
    ContratosGestaoService
  ]
})
export class RelatorioEditaisCotacoesPage extends ModulosController {
  listaDados: any = [];
  listaContratos: any = [];
  listaContratosAux: any = [];
  listaTiposVinculos: any = [];
  listaCargo: any = [];
  loading: boolean = true;
  submetendoNoCertificado: boolean = false;
  idSecaoPagina: string = "145";
  tiposArquivosAceitos: string = "application/xls";
  dadosImportados: any[];

  cpfPreenchido: boolean = false;
  cpfCarregado: boolean = true;
  cpfInvalido: boolean = false;

  cnpjPreenchido: boolean = false;
  cnpjCarregado: boolean = true;
  cnpjInvalido: boolean = false;

  cnpf: string;
  searchLoading: boolean = true;

  editalMask = [/[0-9]/, /[0-9]/, /[0-9]/, '/', /[1-2]/, /[0-9]/, /[0-9]/, /[0-9]/];

  codigoModulo: any = 0;

  contratoParaAdicionar: any = {
    nmContrato: '',
    credor: '',
    cpf: '',
    cnpj: '',
    numeroEditalCotacao: '',
    dataEditalCotacao: ''
  }

  page1: number = 1;

    pagination = {
        TotalItems: 100,
        CurrentPage: 1,
        PageSize: 10,
        TotalPageLinkButtons: 5,
        RowsPerPageOptions: [10]
    };

  myDatePickerEditalOptions: IMyDpOptions;

  typeahead = new EventEmitter<string>();

  objetoEdit: any = null;
  listEdit: any = [];

  comboContratos: any = null;
  analise: any = null;

  @ViewChild('inputFileCM')
  inputFileCMVar: ElementRef;

  desabilitarImportacao = true;

  constructor(public navCtrl: NavController,
    public alertService: AlertService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    public navParams: NavParams,
    public contratoService: ContratoService,
    public contratosGestaoService: ContratosGestaoService,
    private fileService: FileService,
    public gestaoPcaService: GestaoPcaService,
    private menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    this.analise = this.navParams.get('analise');

    this.myDatePickerEditalOptions = {
      dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
      monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
      dateFormat: 'dd/mm/yyyy',
      todayBtnTxt: 'Hoje',
      firstDayOfWeek: 'su',
      disableWeekends: false,
      editableDateField: true,
      openSelectorOnInputClick: true,
      showClearDateBtn: false,
      showSelectorArrow: false,
      openSelectorTopOfInput: true
    };

    if (this.isJurisdicionado) {
      this.codigoModulo = this.navParams.get('analise').idModuloPca;
    }

    this.carregarDados();
    this.setModuloId(14);

    //this.typeahead
    //  .pipe(
    //    distinctUntilChanged(), 
    //    debounceTime(200), 
    //    switchMap(term => this.buscarContratos(term)))
    //  .subscribe(items => {
    //    this.listaContratos = items;
    //  }, (err) => {
    //    console.log(err);
    //    this.listaContratos = [];
    //  });
  }

  carregarDados() {
   /* this.contratosGestaoService.obterAnalise(this.idSecaoPagina).subscribe(data => {
      this.listaDados = data;
      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
    });*/

    this.desabilitarImportacao = true;

    this.loading = true;
    this.contratosGestaoService.obterAnalisePag(1, this.idSecaoPagina).subscribe(data => {
      this.listaDados = data.analises;
      this.loading = false;
      this.pagination.TotalItems = data.qtdPags;
      this.desabilitarImportacao = this.listaDados.length > 0;
  }, error => {
      console.log("erro: " + error);
      this.loading = false;
  });

  this.searchLoading = true;
    this.contratosGestaoService.obterContratosGestao().subscribe(data => {
      this.listaContratos = data;
      this.searchLoading = false;
    }, error => {
      console.log("erro: " + error);
      this.searchLoading = false;
    });
  }

  buscarContratos(term: string): Observable<any[]> {
    return this.contratosGestaoService.obterContratosGestaoPorNumero(term);
  }

  fileChangeMassa(event) {
    this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", callback => {
      if (callback) {
        this.loading = true;
        this.fileService.cargaAnalises(event, this.idSecaoPagina).subscribe(data => {
          this.inputFileCMVar.nativeElement.value = "";
          this.dadosImportados = data;

          for (let j = 0; j < this.dadosImportados.length; j++) {
            this.listaDados.push(this.dadosImportados[j]);
          }

          this.alertService.mostraAlerta("Importação concluída.","Para efetivar a importação, clique em salvar ou finalizar.");
          this.loading = false;
        }, error => {
          this.inputFileCMVar.nativeElement.value = "";
          this.alertService.mostraAlerta("Houve um erro ao carregar o arquivo.", error.mensagem);
          this.loading = false;
        });
      } else {
        this.inputFileCMVar.nativeElement.value = "";
      }
    });
  }

  onCNPJAlterado() {
    let cnpf = this.cnpf;
    if (cnpf.length === 11) {
      cnpf = cnpf.replace(/\D/g, ''); //Remove tudo o que não é dígito
      cnpf = cnpf.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
      cnpf = cnpf.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
      //de novo (para o segundo bloco de números)
      cnpf = cnpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      if (this.validarCPF(cnpf)) {
        this.cpfInvalido = false;
        this.contratoParaAdicionar.cpf = cnpf;
        this.contratoParaAdicionar.cnpj = '';
        this.cnpf = cnpf;
      }
      else {
        this.cpfPreenchido = false;
        this.cnpf = "";
        alert("CPF inválido!");
      }
    } else if (cnpf.length === 14) {
      cnpf = cnpf.replace(/\D/g, ''); //Remove tudo o que não é dígito
      cnpf = cnpf.replace(/(\d{2})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
      cnpf = cnpf.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
      //de novo (para o segundo bloco de números)
      cnpf = cnpf.replace(/(\d{3})(\d)/, '$1/$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
      cnpf = cnpf.replace(/(\d{4})(\d{1,2})$/, '$1-$2');
      if (this.validarCNPJ(cnpf)) {
        this.cnpjInvalido = false;
        this.contratoParaAdicionar.cnpj = cnpf;
        this.contratoParaAdicionar.cpf = '';
        this.cnpf = cnpf;
      }
      else {
        this.cnpjPreenchido = false;
        this.cnpf = "";
        alert("CNPJ inválido!");
      }
    }
  }

  validarCPF(cpf) {
    let ehValido = true;

    cpf = cpf.replace(/[^\w\s]/gi, '');

    if (cpf == '') {
      this.cpfInvalido = false;
      return false;
    }

    if (cpf.length != 11) {
      this.cpfInvalido = false;
      return false;
    }

    // Elimina CPFs invalidos conhecidos
    if (cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" ||
      cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" ||
      cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") {
      this.cpfInvalido = true;
      return false;
    }

    // Valida 1o digito
    let add = 0;
    for (let i = 0; i < 9; i++)
      add += parseInt(cpf.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(9))) {
      this.cpfInvalido = true;
      return false;
    }

    // Valida 2o digito
    add = 0;
    for (let i = 0; i < 10; i++) {
      add += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(10))) {
      this.cpfInvalido = true;
      return false;
    }

    return ehValido;
  }

  validarCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj == '') {
      this.cnpjInvalido = false;
      return false;
    }

    if (cnpj.length != 14) {
      this.cnpjInvalido = false;
      return false;
    }

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
      cnpj == "11111111111111" ||
      cnpj == "22222222222222" ||
      cnpj == "33333333333333" ||
      cnpj == "44444444444444" ||
      cnpj == "55555555555555" ||
      cnpj == "66666666666666" ||
      cnpj == "77777777777777" ||
      cnpj == "88888888888888" ||
      cnpj == "99999999999999") {
      this.cnpjInvalido = true;
      return false;
    }

    let tamanho: any;
    let numeros: any;
    let digitos: any;
    let soma: any;
    let pos: any;
    let resultado: any;

    // Valida DVs
    tamanho = cnpj.length - 2
    numeros = cnpj.substring(0, tamanho);
    digitos = cnpj.substring(tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0)) {
      this.cnpjInvalido = true;
      return false;
    }

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1)) {
      this.cnpjInvalido = true;
      return false;
    }

    //this.cnpjInvalido = true;
    return true;
  }

  downloadDoModelo() {
    this.fileService.downloadModeloCargaContratoGestao(this.idSecaoPagina);
  }

  cpf_mask(v) {
      if(v){
          v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
          v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
          //de novo (para o segundo bloco de números)
          v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
          return v;
      }
  }

  cnpj_mask(v) {
      if(v){
          v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
          v = v.replace(/(\d{2})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
          //de novo (para o segundo bloco de números)
          v = v.replace(/(\d{3})(\d)/, '$1/$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{4})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
          return v;
      }
  }

  adicionarContrato() {

    if (this.contratoParaAdicionar.numeroEditalCotacao != '' &&
      this.contratoParaAdicionar.dataEditalCotacao != '' &&
      this.contratoParaAdicionar.nmContrato != '') {

      if(!this.contratoParaAdicionar.numeroEditalCotacao.match("[0-9][0-9][0-9]\\/[1-2][0-9][0-9][0-9]")){
        this.alertService.mostraAlerta("", "Nº Edital/Cotação inválido");
        return;
      }    

      let contratoNovo = {
        "id": 0,
        "idModuloAnalise": 0,
        "contratoGestao": {
          "id": 0,
          "nmContrato": this.contratoParaAdicionar.nmContrato,
          "credor": "",
          "cpf": "",
          "cnpj": "",
          "objeto": "",
          "dataAssinatura": "",
          "inicioVigencia": "",
          "fimVigencia": "",
          "dataPublicacao": "",
          "valorInicial": 0,
          "responsavel": "",
          "novaDataVigencia": "",
          "valorAtual": 0,
          "aditivos": [],
          "flCertificado": false,
          "situacao": "",
          "dtPrazoPublicacao": "",
          "diasForaDoPrazo": "",
          "codSituacao": 0,
          "arquivos": []
        },
        "dsMetas": "",
        "dsAtividade": "",
        "quantidadePrevista": 0,
        "valorUnitarioPrevisto": 0,
        "totalPrevisto": 0,
        "quantidadeRealizada": 0,
        "valorUnitarioRealizado": 0,
        "totalRealizado": 0,
        "recursosRecebidos": 0,
        "restituicoes": 0,
        "transferencias": 0,
        "rendAcumulados": 0,
        "outrasReceitas": 0,
        "despesasPeriodo": 0,
        "despesasFinanceiras": 0,
        "tipoDespesa": "",
        "naturezaDespesa": "",
        "numeroCheque": "",
        "dataEmissao": "",
        "dataPagamento": "",
        "valorDocumento": "",
        "valorPago": "",
        "credor": this.contratoParaAdicionar.credor,
        "cpf": this.contratoParaAdicionar.cpf,
        "cnpj": this.contratoParaAdicionar.cnpj,
        "numeroEditalCotacao": this.contratoParaAdicionar.numeroEditalCotacao,
        "dataEditalCotacao": this.contratoParaAdicionar.dataEditalCotacao,
        "exercicio": "",
        "valorRetirado": 0,
        "dataRetornoRecurso": "",
        "valorRetorno": 0,
        "valorCorrecao": 0,
        "justificativa": "",
        "destinacaoValor": "",
        "prazoReposicao": "",
        "orgSocial": "",
        "nomePessoa": "",
        "dataAdmissao": "",
        "dataDesligamento": "",
        "funcaoDesenvolvida": "",
        "valorJaneiro": 0,
        "valorFevereiro": 0,
        "valorMarco": 0,
        "valorAbril": 0,
        "valorMaio": 0,
        "valorJunho": 0,
        "valorJulho": 0,
        "valorAgosto": 0,
        "valorSetembro": 0,
        "valorOutubro": 0,
        "valorNovembro": 0,
        "valorDezembro": 0,
        "totalExercicio": 0
      };

      // let tipoVinculoTemp = this.listaContratosAux.filter((contrato) => this.contratoParaAdicionar.nmContrato == contrato.nmContrato)[0];

      this.contratoService.obterPorNumeroContrato(this.contratoParaAdicionar.nmContrato).subscribe(data => {
        if (data != null) {
          contratoNovo.contratoGestao.id = data.id;
          contratoNovo.contratoGestao.nmContrato = data.nmContrato;
          contratoNovo.contratoGestao.credor = data.credor;
          contratoNovo.contratoGestao.cpf = data.cpf;
          contratoNovo.contratoGestao.cnpj = data.cnpj;
          contratoNovo.contratoGestao.objeto = data.objeto;
          contratoNovo.contratoGestao.dataAssinatura = data.dataAssinatura;
          contratoNovo.contratoGestao.inicioVigencia = data.inicioVigencia;
          contratoNovo.contratoGestao.fimVigencia = data.fimVigencia;
          contratoNovo.contratoGestao.dataPublicacao = data.dataPublicacao;
          contratoNovo.contratoGestao.valorInicial = data.valorInicial;
          contratoNovo.contratoGestao.responsavel = data.responsavel;
          contratoNovo.contratoGestao.novaDataVigencia = data.novaDataVigencia;
          contratoNovo.contratoGestao.valorAtual = data.valorAtual;
          contratoNovo.contratoGestao.aditivos = data.aditivos;
          contratoNovo.contratoGestao.flCertificado = data.flCertificado;
          contratoNovo.contratoGestao.situacao = data.situacao;
          contratoNovo.contratoGestao.dtPrazoPublicacao = data.dtPrazoPublicacao;
          contratoNovo.contratoGestao.diasForaDoPrazo = data.diasForaDoPrazo;
          contratoNovo.contratoGestao.codSituacao = data.codSituacao;
          contratoNovo.contratoGestao.arquivos = data.arquivos;
        }

        if (this.objetoEdit) {
          let index = this.listaDados.indexOf(this.objetoEdit);
          this.listaDados.splice(index, 1);

          this.listEdit.push(this.objetoEdit);
        }

        this.listaDados.push(contratoNovo);

        this.objetoEdit = null;

        this.contratoParaAdicionar.nmContrato =
          this.contratoParaAdicionar.credor =
          this.contratoParaAdicionar.numeroEditalCotacao =
          this.contratoParaAdicionar.dataEditalCotacao = '';

        this.comboContratos = null;

        let copyDate = {
          dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
          monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
          dateFormat: 'dd/mm/yyyy',
          todayBtnTxt: 'Hoje',
          firstDayOfWeek: 'su',
          disableWeekends: false,
          editableDateField: true,
          openSelectorOnInputClick: true,
          showClearDateBtn: false,
          showSelectorArrow: false
        };

        this.myDatePickerEditalOptions = copyDate;

      }, error => {
        console.log("erro: " + error);
        this.searchLoading = false;
      });
    }

  }

  onContratoChange(contrato) {

    if (contrato != null && contrato != undefined) {

      if (contrato.cnpj != null && contrato.cnpj != undefined && contrato.cnpj != '') {
          var cnpf = contrato.cnpj;
          cnpf = cnpf.replace(/\D/g, ''); //Remove tudo o que não é dígito
          cnpf = cnpf.replace(/(\d{2})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
          cnpf = cnpf.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
          //de novo (para o segundo bloco de números)
          cnpf = cnpf.replace(/(\d{3})(\d)/, '$1/$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
          cnpf = cnpf.replace(/(\d{4})(\d{1,2})$/, '$1-$2'); 
          this.cnpf = cnpf;
          this.contratoParaAdicionar.cnpj = cnpf;
      } else if (contrato.cpf != null && contrato.cpf != undefined && contrato.cpf != '') {
          var v = contrato.cpf;
          v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
          v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
          //de novo (para o segundo bloco de números)
          v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); 
          this.cnpf = v;
          this.contratoParaAdicionar.cpf = v;
      }
      this.contratoParaAdicionar.nmContrato = contrato.nmContrato;
      this.contratoParaAdicionar.credor = contrato.dsCredor;
    } else {
      this.contratoParaAdicionar.nmContrato = '';
      this.contratoParaAdicionar.credor = '';
      this.contratoParaAdicionar.cpf = '';
      this.contratoParaAdicionar.cnpj = '';
    }
  }

  removerContrato(item, edit) {

    if (!edit) {
      this.alertService.mostraModalConfirmacao("Remover Item", "Deseja remover o item?", callback => {
        if (callback) {

          let index = this.listaDados.indexOf(item);
          this.listaDados.splice(index, 1);

          if (item.id != 0) {
            this.deletarContrato(item.id, edit);
          }
        }
      });
    } else {
      // let index = this.listaDados.indexOf(item);
      // this.listaDados.splice(index, 1);

      if (item.id != 0) {
        this.deletarContrato(item.id, edit);
      }
    }
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  voltarParaContratosGestao() {
    this.menuService.redirecionarPagina(this.contratosGestaoService.obterIdPaginaContratosGestao());
  }

  salvar() {

    this.listEdit.forEach(item => {
      this.removerContrato(item, true);
    });

    this.listEdit = [];

    this.contratosGestaoService.salvarAnalise(this.listaDados, this.idSecaoPagina).subscribe(data => {
      this.alertService.mostraAlerta("", "Salvo com sucesso.");
      this.carregarDados();
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
    })
  }

  deletarContrato(idContratoGestao, edit) {
    this.contratosGestaoService.deletarAnalise(idContratoGestao, this.idSecaoPagina).subscribe(data => {
      if (!edit) {
        this.alertService.mostraAlerta("", "Removido com sucesso.");
      }
    }, error => {
      this.alertService.mostraAlerta("Erro ao excluir", "O registro pode estar vinculado a outra análise no sistema.");
      this.carregarDados();
    })
  }

  finalizar() {

    this.listEdit.forEach(item => {
      this.removerContrato(item, true);
    });

    this.listEdit = [];

    if (this.listaDados) {
      this.contratosGestaoService.finalizarAnalise(this.listaDados, this.idSecaoPagina).subscribe(data => {
        this.alertService.mostraAlerta("", "Finalizado com sucesso.");
        this.voltarParaContratosGestao();
      }, error => {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar:" + error);
      });
    }
  }


  onDataEditalChanged(event: IMyDateModel) {
    if (event.formatted !== '') {
      this.contratoParaAdicionar.dataEditalCotacao = new Date(event.jsdate).toLocaleDateString('pt-br');
    }
  }


  modalEvidencias(item: any) {

    let titulo = "Evidências";

    let modal = this.modalCtrl.create(ModalArquivosPage,
      {
        titulo: titulo,
        IdProcesso: item.contratoGestao.nmContrato,
        idModuloPCA: this.codigoModulo,
        tipoAnalise: 0,
        jurisdicionado: this.isJurisdicionado,
        isCGE: this.isCGE,
        origemArquivo: "Processo: " + item.contratoGestao.nmContrato,
        tipoEntidadeExercicio: 0,
        tipodocumento: 0,
        analise: this.analise
      });

    modal.present();

  }

  editar(item) {
    this.comboContratos = item.contratoGestao.nmContrato;
    this.contratoParaAdicionar.nmContrato = item.contratoGestao.nmContrato;
    this.contratoParaAdicionar.credor = item.contratoGestao.credor;
    this.contratoParaAdicionar.numeroEditalCotacao = item.numeroEditalCotacao;
    this.contratoParaAdicionar.dataEditalCotacao = item.dataEditalCotacao;

    this.objetoEdit = item;
  }

  printData() {

    var doc = new jsPDF("l");
    var totalPagesExp = "{total_pages_count_string}";

    var pageContent = function (data) {
      // HEADER
      doc.setFontSize(20);
      doc.setTextColor(40);
      doc.setFontStyle('normal');

      doc.text("Editais e Cotações", data.settings.margin.left + 15, 22);

      // FOOTER
      var str = "Page " + data.pageCount;
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + " of " + totalPagesExp;
      }
      doc.setFontSize(10);
      doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
    };

    var columns = [
      { title: "Nº Contrato SAC/SCC", dataKey: "contrato" },
      { title: "Organização Social", dataKey: "org" },
      { title: "Nº Edital/Cotação", dataKey: "edital" },
      { title: "Data Edital/Cotação", dataKey: "data" }
    ];

    let rows = [];

    this.listaDados.forEach(contrato => {

      var item = {
        "contrato": contrato.contratoGestao.nmContrato,
        "org": contrato.contratoGestao.credor,
        "edital": contrato.numeroEditalCotacao,
        "data": contrato.dataEditalCotacao
      };

      rows.push(item);
    });

    doc.autoTable(columns, rows, {
      theme: 'grid',
      addPageContent: pageContent,
      margin: { top: 30 },
      styles: {
        overflow: 'linebreak',
        columnWidth: 'auto',
        fontSize: 8
      },
      columnStyles: {
        desc: { columnWidth: 'auto' }
      }
    });

    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }

    doc.save('relatorio_editais_cotacoes.pdf');
  }

  loadPage(Page: number) {
    this.pagination.CurrentPage = Page;
    this.loading = true;
    this.contratosGestaoService.obterAnalisePag(Page, this.idSecaoPagina).subscribe(data => {
      this.listaDados =  data.analises;
      this.loading = false;
      this.pagination.TotalItems = data.qtdPags;
    }, error => {
      console.log("erro: " + error.mensagem);
      this.loading = false;
    });
  }
  
  deletarTodos(){
    this.alertService.mostraModalConfirmacao("Excluir os registros", "Deseja excluir " + this.pagination.TotalItems + " registro(s)?", callback => {
        if (callback) {
            this.loading = true;
            this.contratosGestaoService.deletarTodos(this.idSecaoPagina).subscribe(data => {
                this.alertService.mostraAlerta("Exclusão concluída","Todos os registros foram excluídos.");
                this.carregarDados();
            }, error => {
                console.log("erro: " + error);
                this.alertService.mostraAlerta("Erro ao excluir", "Algum registro pode estar vinculado a outra análise no sistema.");
                this.carregarDados();                   
            });
        }
    });        
  }

  importarDoAnoAnterior() {

    this.alertService.mostraModalConfirmacao("Importar do Ano Anterior", 
        "Recomenda-se realizar a importação dos dados por meio do template de carga em massa."+
        "<br />Deseja continuar a importação dos registros do ano anterior mesmo assim?", 
        callback => {            
            if (callback) {
                this.loading = true;
                this.desabilitarImportacao = true;
                this.contratosGestaoService.carregarAnoAnterior(this.idSecaoPagina).subscribe(data => {
                    this.alertService.mostraAlerta("", data.mensagem);
                    this.carregarDados();
                }, error => {
                    console.log("erro: " + error.mensagem);
                    this.alertService.mostraAlerta("Erro ao importar", error.mensagem);
                    this.carregarDados();
                });
            }
        }
    );

  }

}



// WEBPACK FOOTER //
// ./src/pages/modulos/contratos-gestao/relatorio-editais-cotacoes/relatorio-editais-cotacoes.ts